import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ChangeOrderBackButton,
	ChangeOrderFiles,
	ChangeOrderProducts,
	ExitButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProgress,
	SubmitChangeOrderButton
} from '../../../features/cfi/retail-order';
import { FileTypes } from '../../../types/enums';
import '../../../css/order.scss';

export default function ChangeOrderPage() {

	return (
		<RetailOrderPage>

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<ChangeOrderBackButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<SubmitChangeOrderButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<RetailOrderCommunicationButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<RetailOrderFilesButton defaultFileType={FileTypes.PostTemplateDrawing} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<RetailOrderAddNoteButton showNoteType={false} changeOrder={true} />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<RetailOrderDatesPanel
						showScheduledInstallDates={false}
						showInvoiceDate={false}
						editCabinetDates={false} />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<ChangeOrderFiles />

			<ChangeOrderProducts />

		</RetailOrderPage>
	)
}
